'use client'

import { type ComponentType, useEffect, useState } from 'react'

type ReactQueryDevtoolsComponent = ComponentType<{
  initialIsOpen?: boolean
}>

/**
 * Query Devtools creates a portal container while its module is evaluated.
 * Loading it only after the initial commit keeps the document hydration tree
 * identical between the server and the browser. It is development-only.
 */
export function DeferredReactQueryDevtools() {
  const [Devtools, setDevtools] = useState<ReactQueryDevtoolsComponent | null>(
    null,
  )

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return

    let mounted = true

    void import('@tanstack/react-query-devtools').then(
      ({ ReactQueryDevtools }) => {
        if (mounted) setDevtools(() => ReactQueryDevtools)
      },
    )

    return () => {
      mounted = false
    }
  }, [])

  return Devtools ? <Devtools initialIsOpen={false} /> : null
}
